<template>
	<section v-if="items.length" class="section-bg">
		<div class="mosaic-wrapper">
			<div class="mosaic-row">
				<div v-for="row in items" :key="row.position" :class="`layout-${row.layout}`" class="mosaic-section">
					<div
						v-for="(tessera, idx) in row.tessera"
						:key="idx"
						:class="{ 'mosaic-text-content': !tessera.image }"
						class="mosaic-content"
					>
						<picture v-if="tessera.image">
							<source :srcset="tessera.imageWebp" type="image/webp" />
							<source :srcset="tessera.image" />
							<img class="mosaic-img" :src="tessera.image" loading="lazy" :alt="tessera.imageAlt" />
						</picture>
						<span v-else v-parse-links v-html="tessera.content" />
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<script setup>
defineProps({
	items: { type: Array, default: () => [] },
});
</script>

<style lang="scss" scoped>
.section-bg {
	background-color: var(--secondary-background-color);
}

.mosaic-wrapper {
	width: 100%;
	padding: 10px 70px;
	max-width: 1680px;
	margin: auto;

	.mosaic-row {
		display: grid;
		grid-template-columns: repeat(2, 1fr);
		gap: 15px;

		.mosaic-section {
			display: grid;
			grid-template-columns: repeat(2, 1fr);
			grid-template-rows: repeat(2, 26vw);
			gap: 15px;

			.mosaic-content {
				padding: 0;
				text-align: center;
				background: var(--primary-background-color);
				box-shadow: 0 0 10px rgb(0 0 0 / 5%);

				:deep(p) {
					font-size: 18px;
					line-height: 28px;
					margin-bottom: 30px;
				}

				:deep(h2),
				:deep(h3),
				:deep(h4) {
					font-size: 30px;
					margin: 30px 0;
				}

				img {
					width: 100%;
					height: 100%;
					object-fit: cover;
					display: block;
				}
			}

			.mosaic-text-content {
				padding: 5px 25px;
				display: flex;
				align-items: center;
			}
		}
	}
}

.layout-2 .mosaic-content:nth-child(1),
.layout-4 .mosaic-content,
.layout-5 .mosaic-content:nth-child(2) {
	grid-row: span 2;
}

.layout-3 .mosaic-content:nth-child(1),
.layout-6 .mosaic-content:nth-child(3),
.layout-7 .mosaic-content {
	grid-column: span 2;
}

.layout-8 .mosaic-content {
	grid-area: span 2 / span 2;
}

@media (max-width: 1480px) {
	.mosaic-wrapper {
		.mosaic-row {
			.mosaic-section {
				.mosaic-content {
					:deep(p) {
						font-size: 14px;
						line-height: 22px;
					}

					:deep(h2),
					:deep(h3),
					:deep(h4) {
						font-size: 28px;
					}
				}
			}
		}
	}
}

@media (max-width: 1400px) {
	.mosaic-wrapper {
		.mosaic-row {
			.mosaic-section {
				grid-template-rows: repeat(2, 30vw);
			}
		}
	}
}

@media (max-width: 1280px) {
	.mosaic-wrapper .mosaic-row .mosaic-section .mosaic-text-content {
		padding: 25px;
	}
}

@media (max-width: 1280px) {
	.mosaic-wrapper .mosaic-row {
		grid-template-columns: 1fr;

		.mosaic-section {
			grid-template-rows: repeat(2, 50vw);
		}
	}
}

@media (max-width: 750px) {
	.mosaic-wrapper .mosaic-row .mosaic-section {
		grid-template-columns: 1fr;
		grid-template-rows: auto;
	}

	.layout-2 .mosaic-content:nth-child(1),
	.layout-3 .mosaic-content:nth-child(1),
	.layout-4 .mosaic-content,
	.layout-5 .mosaic-content:nth-child(2),
	.layout-6 .mosaic-content:nth-child(3),
	.layout-7 .mosaic-content,
	.layout-8 .mosaic-content {
		grid-area: auto / auto;
	}

	.mosaic-wrapper .mosaic-row .mosaic-section .mosaic-text-content {
		padding: 50px 15px;
	}

	.mosaic-wrapper {
		padding: 50px 15px;
	}

	.mosaic-content {
		min-height: 75vw;
	}
}
</style>
